import { Col, Row } from 'client/CommonComponents'
import React from 'react'


const ViewAssessment = (props: any) => {

  const { data } = props

  const apiToReactData = JSON.parse(JSON.stringify(data))
  apiToReactData.assessmentQuestionVM = apiToReactData.assessmentQuestionVM.reduce((acc: any[], cur: any) => {
    let options: any = []
    if (cur.option1) {
      options.push({
        optionValue: cur.option1,
        isAnswer: cur.Option1Answer,
      })
    }
    if (cur.option2) {
      options.push({
        optionValue: cur.option2,
        isAnswer: cur.Option2Answer,
      })
    }
    if (cur.option3) {
      options.push({
        optionValue: cur.option3,
        isAnswer: cur.Option3Answer,
      })
    }
    if (cur.option4) {
      options.push({
        optionValue: cur.option4,
        isAnswer: cur.Option4Answer,
      })
    }
    cur.options = options
    acc = acc.concat(cur)
    return acc
  }, [])


   return (
    <>
      <div className='view-header'>
        <div className='mb-1 top-section'>
          <p>{apiToReactData?.assessmentTitle}</p>
          <p className='subText-question mb-2'># of Question : {apiToReactData?.numberOfQuestion}</p>
        </div>
        <div  className='view-left-header mb-xl-1 mb-2'>
          <div className='mx-md-3 me-2 correct-answer-block'>
            <div className='filled-square'></div>
            <p className='mx-2'>Correct Answer</p>
          </div>
          <div className='passing-score mb-2'>
            Passing Score Percentage: {apiToReactData?.passingPercentage}%
          </div>
        </div>
      </div>
      {apiToReactData.assessmentQuestionVM?.map((question: any, index: number) => (
        <div key={question.assesmentQuestionId} className='option-block'>
          <p>Question {index + 1}</p>
          <p className='quest-text'>{question.question}</p>
          <Row className='options'>
            {question?.options?.map((option: any, idx: number) => { console.log(option.isAnswer, 'options'); return(
              <Col key={'option'+ idx} xs={12} sm={12} md={3} lg={3} xl={3} className='mb-md-0 mb-2'>
                <div className='correct-answer-block'>
                  <div className={option.isAnswer ? 'filled-square' : 'empty-square'}>{String.fromCharCode('A'.charCodeAt(0) + idx)}</div>
                  <div className='mx-2'>{option.optionValue}</div>
                </div>
              </Col>
            )})}
          </Row>
          </div>
      ))}
    </>
  )
}

export default ViewAssessment